var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddvid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0399 13.6468C17.0601 14.0963 16.9892 14.5452 16.8313 14.9679C16.6734 15.3906 16.4316 15.7788 16.1198 16.1102C15.8079 16.4417 15.4321 16.7099 15.0139 16.8995C14.5957 17.0891 14.1433 17.1963 13.6826 17.2152C13.5397 17.2257 13.3963 17.2257 13.2535 17.2152H6.58163C6.1227 17.2523 5.66077 17.2004 5.22252 17.0624C4.78427 16.9244 4.37837 16.7031 4.0283 16.4112C3.67823 16.1193 3.39093 15.7626 3.18296 15.3618C2.97499 14.961 2.85047 14.5239 2.81663 14.0759C2.80592 13.933 2.80592 13.7897 2.81663 13.6468V6.3218C2.79648 5.87233 2.86738 5.42336 3.02528 5.00066C3.18317 4.57796 3.42495 4.18979 3.7368 3.85835C4.04864 3.52692 4.42443 3.25872 4.84264 3.06912C5.26084 2.87952 5.71326 2.77225 6.17402 2.75341H13.2642C14.1904 2.68677 15.1061 2.979 15.8129 3.56666C16.5197 4.15433 16.9606 4.99005 17.0399 5.89272C17.0399 6.02876 17.0399 6.16481 17.0399 6.30085V13.6468Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 9.10532L21.4369 5.59978C21.6552 5.42509 21.9353 5.34138 22.2164 5.36685C22.4975 5.39232 22.757 5.52491 22.9386 5.73582C23.0985 5.92409 23.1858 6.16099 23.1853 6.40549V13.5945C23.186 13.7925 23.1291 13.9867 23.0212 14.1544C22.9133 14.3222 22.7588 14.4565 22.5757 14.542C22.3926 14.6275 22.1884 14.6605 21.9868 14.6373C21.7852 14.6141 21.5946 14.5355 21.4369 14.4108L17.0391 10.9052",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "#0FE465",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddvid);
export default __webpack_public_path__ + "static/media/addvid.7c2b5720362e0493578671824b8a8692.svg";
export { ForwardRef as ReactComponent };